


import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate"
import Loader from '../loader/Loader';
const MaterialAcceptanceDetailsModal = ({ show, handleClose, materialId }) => {
  const [inspection, setInspection] = useState([]);
 const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (show && materialId) {
      fetchInspection(materialId);
    }
  }, [show, materialId]);

  const fetchInspection = async (materialId) => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/materialacceptancedetails/${materialId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = response?.data?.material;
      setInspection(data)
      console.log(data, "data")

    } catch (err) {
      console.error("Error fetching material:", err.message);
      setInspection(null);
    }finally{
      setLoading(false)
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className='font_family'>
   {
    loading ? (
      <Loader/>
    ) :(
         <Modal.Body className='p-4'>
        <strong className='fs-4'>Material Acceptance Details</strong>
        {/* Request Information */}
        <div className="p-3 mb-4 bg-light mt-4">
          <Row>
            <Col><strong>Material Name:</strong> {inspection?.material_master?.material_name}</Col>
            <Col><strong>Material ID:</strong> {inspection?.material_master?.material_code}</Col>
          </Row>
          <Row className="mt-2">
            <Col><strong>Qty:</strong> {inspection?.expected_qty}</Col>
            <Col>
              <strong>Date of Request:</strong> {formatDate(inspection?.created_at)}
            </Col>
          </Row>
           <Row className="mt-2">
            <Col><strong>Supplier:</strong> {inspection?.supplier_name}</Col>
          </Row>
        </div>

        {/* Inspection Checklist */}
        <div className="p-3 mb-4 bg-light">
          <Form.Group>
            {inspection?.visual_inspection === 1 && (
              <Form.Check
                label="Visual Inspection (No visible defects)"
                checked
                readOnly
              />
            )}
            {inspection?.dimensional_check === 1 && (
              <Form.Check
                label="Dimensional Check (Meets specifications)"
                checked
                readOnly
              />
            )}
            {inspection?.quantity_check === 1 && (
              <Form.Check
                label="Quantity Check (Matches delivery note)"
                checked
                readOnly
              />
            )}
            {inspection?.packaging_condition === 1 && (
              <Form.Check
                label="Packaging Condition (No damage)"
                checked
                readOnly
              />
            )}
            {inspection?.material_certificate === 1 && (
              <Form.Check
                label="Material Certificate (Provided and valid)"
                checked
                readOnly
              />
            )}
          </Form.Group>
        </div>


        {/* Quantity Accepted */}
        <Row className="mb-3">
          <Col md={2}>
            <Form.Label><strong>Quantity Accepted</strong></Form.Label>
          </Col>
          <Col md={3}>
            <div className="d-flex align-items-center">
              <Form.Control value={inspection?.actual_quantity} readOnly />
              <span className="ms-2">{inspection?.material_master?.unit_of_measurement}</span>
            </div>
          </Col>

              <Col md={2}>
            <Form.Label><strong>Quantity Rejected</strong></Form.Label>
          </Col>
          <Col md={3}>
            <div className="d-flex align-items-center">
              <Form.Control value={inspection?.quantity_rejected} readOnly />
              <span className="ms-2">{inspection?.material_master?.unit_of_measurement}</span>
            </div>
          </Col>
        </Row>

        {/* Notes */}
        <Row>
          <Col md={2}>
            <Form.Label><strong>Notes</strong></Form.Label>
          </Col>
          <Col md={10}>
            <Form.Control as="textarea" rows={3} value={inspection?.notes} readOnly />
          </Col>
        </Row>
      </Modal.Body>
    )
   }
      <Modal.Footer className='border-0'>
        <Button variant="dark" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MaterialAcceptanceDetailsModal;
